import { useState, useEffect } from 'react';
import { paymentsAPI } from '../lib/api';

// Returns the caller's current subscription plan and derived feature flags.
// AI Video Interviews and Background Verification are excluded from Starter.
export function usePlan() {
  const [plan, setPlan] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    paymentsAPI.getSubscription()
      .then((r) => { if (active) setPlan(r.data?.plan || null); })
      .catch(() => {})
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  const isStarter = plan === 'starter_monthly' || plan === 'starter_annual';
  return {
    plan,
    loading,
    isStarter,
    canUseInterviews: !isStarter,
    canUseBgv: !isStarter,
  };
}
